import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/empty/empty-graphs.svg'


const _hoisted_1 = { id: "adaptive" }
const _hoisted_2 = {
  key: 0,
  class: "w-full flex justify-center"
}
const _hoisted_3 = {
  key: 1,
  class: "w-full h-[680px] relative flex flex-col justify-center items-center space-y-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "text-gray-600 w-[360px] text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LearningMapTeacher = _resolveComponent("LearningMapTeacher")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.graph.nodes && _ctx.graph.nodes.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_LearningMapTeacher, {
            ref: "learningMap",
            node: _ctx.graph,
            role: _ctx.role,
            onOnAddChapter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onAddChapter', $event, _ctx.$refs['learningMap']))),
            onOnAddObjective: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onAddObjective', $event))),
            onOnEditObjective: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onEditObjective', $event))),
            onOnShowObjects: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onShowObjects', $event))),
            onOnShowBlacklist: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('onShowBlacklist', $event)))
          }, null, 8, ["node", "role"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Você visualizará aqui o grafo do seu curso, clique em “Adicionar Capítulo”.",
            en: "You will see the graph of your course here, click on “Add Chapter” ",
          })), 1)
        ]))
  ]))
}